<div class="searchable-dropdown denser">
  <label class="searchable-dropdown-label" [for]="id"
    >{{ label }}<span *ngIf="required"> *</span></label
  >
  <mat-expansion-panel
    class="mat-elevation-z0 searchable-dropdown-expansion-panel"
    appearance="outline"
    #matExpansionPanel
    (opened)="ClearSearch()"
    (closed)="OnExpansionPanelClose()"
    [class.invalid]="control.invalid && control.touched"
  >
    <mat-expansion-panel-header
      class="searchable-dropdown-expansion-header denser"
      expandedHeight="48px"
    >
      <mat-panel-title
        class="searchable-dropdown-expansion-header"
        [class.placeholder]="_placeholder"
        [id]="id"
        >{{ _displayValue }}
      </mat-panel-title>
      <mat-panel-description>
        <mat-icon *ngIf="control.invalid && control.touched" class="error-icon"
          >error_outline</mat-icon
        >
      </mat-panel-description>
    </mat-expansion-panel-header>
    <mat-form-field
      appearance="outline"
      class="densest searchable-dropdown-form-field"
    >
      <input
        type="text"
        placeholder="Search..."
        matInput
        [formControl]="_search"
        class="searchable-dropdown-input"
        (click)="ClearSearch()"
      />
    </mat-form-field>
    <app-link-button
      id="clear-button"
      type="button"
      color="accent"
      (click)="ClearClicked()"
      >Clear</app-link-button
    >
    <div id="result-panel" class="result-panel">
      <div
        *ngFor="let option of _filteredData | async"
        (click)="SetControl(option)"
        class="result-row"
      >
        <span class="result-text">{{ option.label }}</span>
      </div>
    </div>
  </mat-expansion-panel>
  <div
    class="mat-mdc-form-field-subscript-wrapper mat-mdc-form-field-bottom-align"
  >
    <div class="mat-mdc-form-field-error-wrapper">
      <mat-error *ngIf="control.invalid && control.touched"
        >Case Manager is required.</mat-error
      >
    </div>
  </div>
</div>
